import { CmsArticleStatusesEnum } from '~/src/models/enums/cms.enum';
import { fallBackOrder } from '~/src/repositories/cms/constants/cms.constants';
import type { DictionaryInterface } from '~/src/repositories/cms/types/cms.sections.types';
import type {
    CmsInfoBannersArticleAttributeInterface,
    InfoBannersInterface,
} from '~/src/repositories/cms/entities/leads/types/cms.leads.types';

export const getMappedInfoBannersData = (
    data: DictionaryInterface<CmsInfoBannersArticleAttributeInterface>[] | [],
): InfoBannersInterface[] => {
    return (data?.[0]?.articles || [])
        .reduce<InfoBannersInterface[]>((banners, elem) => {
            if (elem?.status === CmsArticleStatusesEnum.PUBLISHED) {
                const contentAttributes = elem.attributeCategories.content?.attributes;

                banners.push({
                    id: elem.id,
                    text: contentAttributes?.text?.value || null,
                    textColor: contentAttributes?.textcolor?.value?.value || null,
                    additionalText: contentAttributes?.additionaltext?.value || null,
                    bannerImage: contentAttributes?.bannerimage?.value || null,
                    bannerGradient: contentAttributes?.bannergradient?.value || null,
                    imageLogo: contentAttributes?.imagelogo?.value || null,
                    link: contentAttributes?.link?.value || null,
                    order: contentAttributes?.order?.value || fallBackOrder,
                });
            }

            return banners;
        }, [])
        .sort((item, elem) => (item?.order || fallBackOrder) - (elem?.order || fallBackOrder));
};
